<div class="pd-histo">
  <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
    <div>
      <h6 class="mb-1">Historique des modifications</h6>

    </div>
    <button
      type="button"
      class="btn rippleEffect"
      style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
      (click)="refreshFromServer()"
    >
      <i class="bi bi-arrow-clockwise me-1" aria-hidden="true"></i>
      Actualiser depuis le serveur
    </button>
  </div>

  <div class="form-row mb-3">
    <div class="form-group col-md-3 mb-2">
      <label class="small">Date du</label>
      <ng2-flatpickr
        class="pd-histo-date-fp w-100"
        name="df"
        [config]="histoDateFlatpickrOptions"
        [(ngModel)]="filterDateFrom"
        (ngModelChange)="applyFilters()"
        placeholder="jj/mm/aaaa"
      ></ng2-flatpickr>
    </div>
    <div class="form-group col-md-3 mb-2">
      <label class="small">Date au</label>
      <ng2-flatpickr
        class="pd-histo-date-fp w-100"
        name="dt"
        [config]="histoDateFlatpickrOptions"
        [(ngModel)]="filterDateTo"
        (ngModelChange)="applyFilters()"
        placeholder="jj/mm/aaaa"
      ></ng2-flatpickr>
    </div>
    <div class="form-group col-md-2 mb-2">
      <label class="small">Utilisateur</label>
      <input class="form-control form-control-sm" [(ngModel)]="filterUser" (ngModelChange)="applyFilters()" name="fu" />
    </div>
    <div class="form-group col-md-2 mb-2">
      <label class="small">Action</label>
      <input class="form-control form-control-sm" [(ngModel)]="filterAction" (ngModelChange)="applyFilters()" name="fa" />
    </div>
    <div class="form-group col-md-2 mb-2">
      <label class="small">Objet</label>
      <input class="form-control form-control-sm" [(ngModel)]="filterObjet" (ngModelChange)="applyFilters()" name="fo" />
    </div>
  </div>

  <app-parametre-donnees-data-table
    [columns]="histoColumns"
    [rows]="tableRows()"
    [emptyMessage]="'Aucune entrée ne correspond aux filtres.'"
  ></app-parametre-donnees-data-table>

  <app-table-pagination-bar
    class="mt-2"
    [totalItems]="filtered.length"
    [pageFrom]="pageFrom"
    [pageTo]="pageTo"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [pageSize]="pageSize"
    [nameSuffix]="'histo-' + moduleKey"
    itemsLabel="ligne(s)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></app-table-pagination-bar>
</div>
